export const className = (...cls: Array<string | boolean | undefined | null>)=> cls.filter(Boolean).join(" ")

const rtlLocales = ["ar", "he", "ug"]

function isRtlLocale(locale: string) {
  const normalizedLocale = locale.toLowerCase().replace(/-/g, "_")
  return rtlLocales.some(t => normalizedLocale === t || normalizedLocale.startsWith(`${t}_`))
}

function isRtlSource(source: string) {
  const normalizedSource = source.toLowerCase().replace(/-/g, "_")
  return rtlLocales.some(t => normalizedSource.includes(`/${t}/`) || normalizedSource.includes(`/${t}_`))
}

export function setDir(locale: string){
  if(isRtlLocale(locale)){
    document.body.dir = "rtl"
  }else if(document.body.dir){
    document.body.removeAttribute("dir")
  }
}

// 部分资源存在fallback，比如he资源没找到，会去找en资源，此时应该移除dir属性
export function fixDir(source: string){
  if(!isRtlSource(source) && document.body.dir){
    document.body.removeAttribute("dir")
  }
}
